import {observer} from 'mobx-react';
import {calendarDate} from 'shared/tools';
import {Table} from 'main/components';
import _ from 'lodash';
import {FormattedMessage} from 'react-intl';

const COLUMNS = [
  {
    header: 'nmbr.updates.directory.Title',
    width: 3,
    attribute: 'title'
  },
  {
    header: 'nmbr.updates.directory.Category',
    width: 3,
    attribute: 'category'
  },
  {
    header: 'nmbr.updates.directory.Date',
    width: 3,
    render: model => calendarDate(model.date)
  },
  {
    header: 'nmbr.updates.directory.Amount',
    width: 3,
    attribute: 'formattedAmount'
  }
];

const ExpenseRequestTable = observer(({nmbrUpdate}) => {
  if (!nmbrUpdate.hasFieldUpdate('expense_reimbursement')) return null;

  return (
    <div className='space-y'>
      <div className='h4 medium'>
        {nmbrUpdate.eventType === 'expense_request_destroyed' ?
          <FormattedMessage id='nmbr.updates.directory.Deleted Expenses'/> :
          <FormattedMessage id='nmbr.updates.directory.Approved Expenses'/>
        }
      </div>
      <Table
        columns={COLUMNS}
        models={_.filter(nmbrUpdate.fieldUpdates, {updateType: 'expense_reimbursement'})}
        showLinks={false}
      />
    </div>
  );
});

export default ExpenseRequestTable;
